/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseProfipreisPosDto } from '../../models/response-profipreis-pos-dto';

export interface GetProfipreis$Params {
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
  id?: string;
  netAmount?: string;
  creationDate?: string;
  validFrom?: string;
  validTo?: string;
}

export function getProfipreis(http: HttpClient, rootUrl: string, params?: GetProfipreis$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseProfipreisPosDto>> {
  const rb = new RequestBuilder(rootUrl, getProfipreis.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
    rb.query('id', params.id, {});
    rb.query('netAmount', params.netAmount, {});
    rb.query('creationDate', params.creationDate, {});
    rb.query('validFrom', params.validFrom, {});
    rb.query('validTo', params.validTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseProfipreisPosDto>;
    })
  );
}

getProfipreis.PATH = '/profipreis';
